/* eslint react/no-danger: 0 */
import React, { Fragment } from 'react';
import ReactGA from 'react-ga';
import Observer from 'react-intersection-observer';
import { Helmet } from 'react-helmet';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import Filter from '../components/Filter';
import Autocomplete from '../components/Autocomplete';
import Disclaimers from '../components/Disclaimers';
import ModalOverlay from '../components/ModalOverlay';
import {
	COMMUNITIES_TO_COLORS,
	COMMUNITIES_TO_NAMES,
	getMapboxKey,
	IDS_TO_COMMUNITIES,
	IDS_TO_GA_COMMUNITIES,
	MAPBOX_KEY,
	ORGS_TO_MAP_IDS,
} from '../constants';
import ToggleableIcon from '../components/ToggleableIcon.js';
import analyticsMap from '../analytics-map';

const mbxTilequery = require('@mapbox/mapbox-sdk/services/tilequery');

const tilequeryClient = mbxTilequery({
	accessToken: MAPBOX_KEY,
});

const MORE_ORGANIZATIONS_COUNT = 3;
const NEARBY_ORGANIZATIONS_COUNT = 3;

function showMore() {
	const dots = document.getElementsByClassName('dots')[0];
	const moreText = document.getElementsByClassName('more-text')[0];
	const btnReadMore = document.getElementsByClassName('btn-read-more')[0];
	const mission = document.getElementsByClassName('mission')[0];
	dots.classList.toggle('hide');
	moreText.classList.toggle('show');
	mission.classList.toggle('show');
	btnReadMore.innerHTML = btnReadMore.innerHTML === 'Read More' ? 'Read Less' : 'Read More';
}

class Organization extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			org: null,
			coordinates: null,
			nearby: [],
			sameCity: [],
			categoryOrgs: [],
			uniqueIds: null,

		};
	}

	componentDidMount() {
		const {location} = this.props;
		const search = this.props.parseQueryString(location.search);
		let fetchBy = 'id';

		if (Number.isNaN(search.search)) {
			fetchBy = 'name';
			search.search = decodeURIComponent(search.search)
				.replace(/-/g, '%20')
				.replace(/%20%20/g, '%20-');
		}

		fetch(`${process.env.PUBLIC_URL}/api/?${fetchBy}=${search.search}`)
			.then(response => {
				if (response.ok) {
					return response.json();
				}
				return Promise.error('data was not received');

			})
			.then(data => {
				this.setState(
					prevState => ({
						org: data.features[0].properties,
						coordinates: data.features[0].geometry.coordinates,
					}),
					() => {
						const {org} = this.state;
						const {category_id} = org;
						if (category_id) {
							this.getCategoryOrgs(category_id);
						}
					},
				);
				this.getNearbyOrgsByCity(data.features[0].properties.city);

				const btnTranscript = document.getElementsByClassName('view-transcript');
				if (btnTranscript.length > 0) this.prepTranscriptLinks(btnTranscript);


			});

		// Can't use  GAfirePageView() since that is a HOOK and this is a component.
		// So have to use raw GA method call.
		ReactGA.pageview(window.location.pathname + window.location.search);
	}

	componentDidUpdate() {
	}

	getNearbyOrgsByCity(city) {
		fetch(`${process.env.PUBLIC_URL}/api/?city=${city}`)
			.then(response => {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(new Error('data was not received'));

			})
			.then(nearbyOrgs => {
				this.setState(prevState => ({
					sameCity: nearbyOrgs.features,
				}));
			});
	}

	getCategoryOrgs(category_id) {
		// get 3 orgs same category, first trying to get from featured, then filling with random from same category
		fetch(`${process.env.PUBLIC_URL}/api/?is_featured`)
			.then(response => {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(new Error('data was not received'));

			})
			.then(featuredOrgs => {
				const uniqueIds = {[this.state.org.id]: true};
				const featuredSameType = [];

				featuredOrgs.features.forEach(item => {
					const featureId = item.properties.id;
					if (
						item.properties.category_id === category_id &&
						!uniqueIds[featureId] &&
						featuredSameType.length < 3
					) {
						uniqueIds[featureId] = true;
						featuredSameType.push(item);
					}
				});

				let categoryOrgsNeeded = MORE_ORGANIZATIONS_COUNT - featuredSameType.length;

				if (categoryOrgsNeeded <= 0) {
					this.setState(
						{
							categoryOrgs: featuredSameType.slice(0, MORE_ORGANIZATIONS_COUNT),
							uniqueIds,
						},
						() => {
							if (this.state.coordinates) this.getNearbyOrgs(this.state.coordinates);
						},
					);
				}
				else {
					this.setState({
						categoryOrgs: featuredSameType,
					});

					fetch(`${process.env.PUBLIC_URL}/api/?category_id=${category_id}`)
						.then(response => {
							if (response.ok) {
								return response.json();
							}
							return Promise.reject(new Error('data was not received'));

						})
						.then(data => {
							const categoryResults = data.features;
							const l = categoryResults.length;
							const additionalOrgs = [];
							let index;
							let org;

							do {
								index = Math.floor(Math.random() * l);
								org = categoryResults[index];
								const {id} = org.properties;

								// might hit same index but array is very large and shift() has terrible performance
								if (!uniqueIds[id]) {
									uniqueIds[id] = true;
									additionalOrgs.push(org);
									categoryOrgsNeeded--;
								}
							} while (categoryOrgsNeeded > 0);

							this.setState((prevState) => ({
								categoryOrgs: prevState.categoryOrgs.concat(additionalOrgs),
								uniqueIds,
							}), () => {
								if (this.state.coordinates) this.getNearbyOrgs(this.state.coordinates);
							});
						});
				}
			});
	}

	getNearbyOrgs(coordinates) {
		const mapIds = [];

		Object.keys(IDS_TO_COMMUNITIES).forEach(key => {
			mapIds.push(ORGS_TO_MAP_IDS[getMapboxKey(key)]);
		});

		function checkDup(item, array) {
			for (let i = 0; i < array.length; i++) {
				if (array[i].properties.id === item.properties.id) {
					return true;
				}
			}
			return false;
		}

		tilequeryClient
			.listFeatures({
				mapIds,
				coordinates,
				// radius in meters
				radius: 500000,
				dedupe: true,
				// in case all happen to be non unique
				limit: NEARBY_ORGANIZATIONS_COUNT + MORE_ORGANIZATIONS_COUNT + 1,
			})
			.send()
			.then(response => {
				const nearbyResponse = response.body.features;

				const nearby = [];
				nearbyResponse.forEach(item => {
					if (!this.state.uniqueIds[item.properties.id] && nearby.length < 3) {
						if (checkDup(item, nearby) === false) {
							nearby.push(item);
						}
					}
				});

				this.setState({
					nearby,
				});
			});
	}

	// eslint-disable-next-line class-methods-use-this
	prepTranscriptLinks(transcriptButtons) {
		[...transcriptButtons].forEach((btn, index) => {
			btn.addEventListener('click', () => {

				btn.classList.toggle('open');
				const curAriaExp = btn.getAttribute('aria-expanded');
				const isExpanded = curAriaExp !== 'false';
				btn.setAttribute('aria-expanded', String(!isExpanded));

				const divTranscript = document.getElementsByClassName('transcript-text')[index];
				divTranscript.classList.toggle('open');
				const curAriaHidden = divTranscript.getAttribute('aria-hidden');
				const isHidden = curAriaHidden !== 'false';
				divTranscript.setAttribute('aria-hidden', String(!isHidden));
			});
		});
	}

	render() {

		const {nearby, categoryOrgs, org} = this.state;
		const {
			location,
			isMobile,
			handleEvent,
			appData,
			stateShowFilter,
			handleFilterClick,
			chooseDropdownType,
			mapLoading,
			results,
			checkForCityOrZip,
			addExitClickListeners,
			closeExitOverlay,
			modalOverlay
		} = this.props;

		const truncate = (orgMission, part) => {
			const viewPort = window.innerWidth;

			let chars;

			switch (true) {
				case (viewPort < 570):
					chars = 120;
					break;
				case (viewPort < 768):
					chars = 150;
					break;
				case (viewPort < 897):
					chars = 130;
					break;
				case (viewPort < 1024):
					chars = 160;
					break;
				default:
					chars = 190;
					break;
			}


			if (orgMission.length <= (chars + 2)) { // add 2 extra chars so can't show more for just 2 chars.
				return false;
			}
			// else
			let newMission = orgMission.substring(0, chars);
			if (part === 2) {
				newMission = orgMission.substring(chars);
			}
			return newMission;


		};

		const getFeaturedOrgItem = (organization, i) => {
			const data = organization.properties;
			const community = IDS_TO_COMMUNITIES[data.category_id];
			const color = COMMUNITIES_TO_COLORS[community];
			const previewTexts = [
				'Our community heroes shouldn\'t feel like homeownership is out of reach. Charlotte-Mecklenberg Housing Partnership Inc is a proud part of our NeighborhoodLIFT® program, helping hundreds of first responders across the U.S. become homeowners.',
				'Strengthening communities starts from within. The Cities for Financial Empowerment Fund is improving stability for households in need by embedding financial empowerment strategies into local government and community infrastructure.',
				'Small businesses are the core of community growth and innovation. Learn how Working Solutions is helping entrepreneurs, like taking Chef GW Chew’s plant-based meat substitutes from restaurant to supermarket, with help from our small business program, Diverse Community Capital.',
			];

			return (
				<article className="featured-org" key={data.id}>
					<div className="relative">
						<div className={`location ${color}`}>
							<div>{community}</div>
							{ /* <img src={bannerImg} aria-hidden="true"/> */}
						</div>
						<a
							href={`${process.env.PUBLIC_URL}/organization/?search=${data.id}`}
							onClick={() => {
								ReactGA.event({
									category: analyticsMap.D1.Category,
									action: analyticsMap.D1.Action,
									label: data.name,
								});
							}}
						>
							<figure className="photo">
								<img
									src={`${process.env.PUBLIC_URL}/images/org/featured/featured-${data.id}.jpg`}
									title={`Featured Organization: ${data.name}`}
									className="featured-image"
									alt={data.name}
								/>
								<figcaption>{data.caption}</figcaption>
							</figure>
						</a>
					</div>
					<h3>
						<a href={`${process.env.PUBLIC_URL}/organization/?search=${data.id}`}>{data.name}</a>
					</h3>
					{/* <p>{data.story.preview}</p> */}
					<p>{previewTexts[i]}</p>
					<a
						href={`${process.env.PUBLIC_URL}/organization/?search=${data.id}`}
						className="text-cta anchor-bottom"
						onClick={() => {
							ReactGA.event({
								category: analyticsMap.D1.Category,
								action: analyticsMap.D1.Action,
								label: data.name,
							});
						}}
					>
						See the Impact
					</a>
				</article>
			);
		};

		const isMac = () => navigator.userAgent.indexOf('Mac OS X') > -1 && 'mac';

		const FEATURED_ORGS_IDS = ['3260602', '3278052', '3778130'];

		const featuredOrgs = [null, null, null];
		let i = 0;
		if (appData.featuredOrgs && appData.featuredOrgs.length) {
			appData.featuredOrgs.forEach((featuredOrg) => {
				const pos = FEATURED_ORGS_IDS.indexOf(featuredOrg.properties.id);
				if (pos !== -1) {
					featuredOrgs[pos] = getFeaturedOrgItem(featuredOrg, i);
					i++;
				}
			});
		}

		if (this.state.org) {
			let tel = org.phone;
			if (org.phone_extension !== '') {
				tel = `${org.phone};${org.phone_extension}`;
			}

			addExitClickListeners();

			return (
				<>
					<Helmet>
						<title>{COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[org.category_id]]} - EIN {org.ein} | Wells Fargo</title>
						{location.search.indexOf('target=district') > -1 ? (
							<meta name="robots" content="noindex, nofollow"/>
						) : (
							<meta name="robots" content="index, follow"/>
						)}
						<meta
							name="description"
							content={
								org.is_featured === '1'
									? `${org.story.meta_desc}»`
									: `Learn about the impact of ${org.name}, how Wells Fargo is helping, and how to get involved.»`
							}
						/>
						<link
							rel="canonical"
							href={`https://welcome.wf.com/impact/organization/?search=${org.id}`}
						/>
						<meta property="og:title" content={`${COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[org.category_id]]} - EIN ${org.ein} | Wells Fargo`}/>
						<meta
							property="og:url"
							content={`https://welcome.wf.com/impact/organization/?search=${org.id}`}
						/>
						<meta
							property="og:description"
							content={
								org.is_featured === '1'
									? `${org.story.meta_desc}»`
									: `Learn about the impact of ${org.name}, how Wells Fargo is helping, and how to get involved.»`
							}
						/>
						<meta
							property="og:image"
							content={
								org.is_featured === '1'
									? `https://welcome.wf.com/impact/images/org/featured/${org.id}.jpg`
									: `https://welcome.wf.com/impact/images/org/categories/${IDS_TO_COMMUNITIES[org.category_id].replace(' ', '-').toLowerCase()}.jpg`
							}
						/>


						<meta property="twitter:title" content={`${COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[org.category_id]]} - EIN ${org.ein} | Wells Fargo`}/>
						<meta
							property="twitter:url"
							content={`https://welcome.wf.com/impact/organization/?search=${org.id}`}
						/>
						<meta
							property="twitter:description"
							content={
								org.is_featured === '1'
									? `${org.story.meta_desc}»`
									: `Learn about the impact of ${org.name}, how Wells Fargo is helping, and how to get involved.»`
							}
						/>
						<meta
							property="twitter:image"
							content={
								org.is_featured === '1'
									? `https://welcome.wf.com/impact/images/org/featured/${org.id}.jpg`
									: `https://welcome.wf.com/impact/images/org/categories/${IDS_TO_COMMUNITIES[org.category_id].replace(' ', '-').toLowerCase()}.jpg`
							}
						/>
					</Helmet>
					<Nav
						handleEvent={handleEvent}
						isNotHomePage
						activePage="organization-detail"
						isMobile={isMobile}
						results={results}
						checkForCityOrZip={checkForCityOrZip}
						location={location}
						stateShowFilter={stateShowFilter}
						mapLoading={mapLoading}
						chooseDropdownType={chooseDropdownType}

					/>
					<div className="IE-for-main organization">
						<main
							className="organization"
							data-is-featured={org.is_featured === '1'}
							data-page="organization"
							aria-label={org.is_featured === '1' ? 'Featured Organization. Contains article.' : undefined}
						>
							<section className="org__details">
								<div className="desktop left">
									<div className={classNames('content', isMac())}>
										<div
											role="link"
											className={`category ${COMMUNITIES_TO_COLORS[IDS_TO_COMMUNITIES[org.category_id]]}`}
											onClick={() => {
												ReactGA.event({
													category: analyticsMap.J1.Category,
													action: IDS_TO_GA_COMMUNITIES[org.category_id],
													label: window.location.href,
												});
												chooseDropdownType(IDS_TO_COMMUNITIES[org.category_id], 'organization')
											}}
											onKeyDown={event => {
												if (event.key === 'Enter') {
													ReactGA.event({
														category: analyticsMap.J1.Category,
														action: IDS_TO_GA_COMMUNITIES[org.category_id],
														label: window.location.href,
													});
													chooseDropdownType(IDS_TO_COMMUNITIES[org.category_id], 'organization')
												}
											}}
											tabIndex="0"
										>
											{COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[org.category_id]]}
										</div>


										<h1 id="organization-detail-main-h1" tabIndex="-1">{org.name}</h1>

										{/* DESKTOP MISSION */}
										{org.mission && (
											<div className={classNames('mission', org.is_featured === '1' && truncate(org.mission, 1) && 'truncated')}>
												{org.is_featured === '1' ? (
													truncate(org.mission, 1) ? ( // check to see if mission is truncated
														<p>
															<span>{truncate(org.mission, 1)}</span>
															<span className="dots">&hellip;</span>
															<span className="more-text">{truncate(org.mission, 2)}</span>
															<button
																type="button"
																className="btn-read-more"
																onClick={() => {
																	showMore();
																}}>
																Read More
															</button>
														</p>
													) : ( // if not, then just show entire mission statement
														<p>
															<span>{org.mission}</span>
														</p>
													)
												) : ( // always show entire mission statement for non-featured orgs
													<p>{org.mission}</p>
												)}
											</div>
										)}

									</div>
								</div>
								<div className="desktop right">
									<div className="content">
										<h3>Get Involved</h3>
										<address>
											<div className="name">
												{org.url !== '' ? (
													<a href={org.url} target="_blank" rel="noopener noreferrer">{org.name}</a>
												) : (
													org.name
												)}
											</div>
											<div className="address">
												{org.address}<br/>
												{org.city ? `${org.city}, ` : ''}{`${org.state} ${org.zip}`}
											</div>
											{tel && (
												<div className="phone">
													Call: <a href={`tel://${tel}`}>{tel}</a>
												</div>
											)}
										</address>
									</div>
								</div>
							</section>
							{org.story && (
								org.story.body && (
									<section className="article">
										<article className="story">
											<div className="content" dangerouslySetInnerHTML={{__html: org.story.body}}/>
											<div className="separator"/>
										</article>
									</section>
								)
							)}

							<section className="org__more">
								<h2>{`More ${COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[org.category_id]]} Organizations`}</h2>
								<div className="group">
									{categoryOrgs.length > 0 ? (
										categoryOrgs.map(nearbyOrg => {
											const data = nearbyOrg.properties;

											return (
												<article key={data.id}>
													<div
														className={
															`category ${
																COMMUNITIES_TO_COLORS[IDS_TO_COMMUNITIES[org.category_id]]}`
														}
													>
														{COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[data.category_id]]}
													</div>
													<div className="content">
														<a href={`${process.env.PUBLIC_URL}/organization/?search=${data.id}`}
														>
															<h3>{data.name}</h3>
															<p>{data.mission.substring(0, 120)}&hellip;</p>
															<span className="text-cta">See the Details</span>
														</a>
													</div>
												</article>
											);
										})
									) : (
										<article>
											<div className="category loading-heading">Loading&hellip;</div>
											<div className="content">
												<h3>Organization</h3>
												<p>&hellip;</p>
											</div>
										</article>
									)}
								</div>
							</section>
							<section className="org__nearby">
								<h2>Other Nearby Organizations</h2>
								<div className="group">
									{nearby.length > 0 &&
										nearby.map(nearbyOrg => {
											const data = nearbyOrg.properties;

											return (
												<article key={data.id}>
													<div
														className={
															`category ${
																COMMUNITIES_TO_COLORS[IDS_TO_COMMUNITIES[data.category_id]]}`
														}
													>
														{COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[data.category_id]]}
													</div>
													<div className="content">
														<a href={`${process.env.PUBLIC_URL}/organization/?search=${data.id}`}
														>
															<h3>{data.name}</h3>
															<p>{data.mission.substring(0, 120)}&hellip;</p>
															<span className="text-cta">See the Details</span>
														</a>
													</div>
												</article>
											);
										})}

									{!(nearby.length > 0) &&
										this.state.sameCity.length > 0 &&
										this.state.sameCity.slice(0, 3).map(sameCityOrg => {
											const data = sameCityOrg.properties;

											return (
												<article key={data.id}>
													<div
														className={
															`category ${
																COMMUNITIES_TO_COLORS[IDS_TO_COMMUNITIES[data.category_id]]}`
														}
													>
														{COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[data.category_id]]}
													</div>
													<div className="content">
														<a href={`${process.env.PUBLIC_URL}/organization/?search=${data.id}`}>
															<h3>{data.name}</h3>
															<p>{data.mission.substring(0, 120)}&hellip;</p>
															<span className="text-cta">See the Details</span>
														</a>
													</div>
												</article>
											);
										})}
								</div>
							</section>
							<Disclaimers/>
              <Footer
                activePage="organization"
              />
						</main>
					</div>
					{modalOverlay && modalOverlay.open && (
						<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
					)}
				</>
			);
		}

		//NO HELMET

		return (
			<>
				<div className="IE-for-main organization">
					<main data-page="organization">
						<section className="organizations results group">
							{/*<section className="organizations__search-controls">
								<ul className="nav-links" role="menu">
									<li>
										<a
											href={`${process.env.PUBLIC_URL}/`}
											onClick={() => {
												this.props.handleEvent({
													action: 'clear-search',
													type: '',
													name: '',
													origin: 'organization'
												});
											}}
										>
											Home
										</a>
									</li>
									<li role="menuitem">
										<Link to="/map/">Map</Link>
									</li>
								</ul>
								<form
									role="search"
									autoComplete="off"
									onSubmit={event => {
										event.preventDefault();
									}}
								>
									<Autocomplete
										orgResults={results.all}
										checkForCityOrZip={checkForCityOrZip}
										handleTextSearch={
											inputObj => {
												handleEvent({
													action: 'input',
													name: 'results',
													value: inputObj,
													origin: 'organization'
												});
												handleEvent({
													action: 'search',
													type: 'input',
													name: 'results',
													origin: 'organization'
												});
											}}
										route="organization"
									/>
								</form>
							</section>*/}
							<section className="org__description loading-heading">
								<div className="copy">
									<div className="category">Loading&hellip;</div>
									<h1>Organization</h1>
									<div className="mission">
										<h2>&hellip;</h2>
										<p>&hellip;</p>
									</div>
								</div>
							</section>
						</section>
						<Disclaimers/>
					</main>
					<Footer
            activePage="organization"
					/>
				</div>
			</>
		);
	}
}

export default withRouter(Organization);


